<template>
  <div class="partner-organisation mb-5">
    <CCard class="mt-2">
      <CCardBody>
        <div class="mb-2 pb-2">
          <CDataTable
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :items="partners"
            :fields="fields"
            :items-per-page="limit"
            sorter
            :tableFilter="{
              label: 'Search',
              placeholder: 'Type for search',
            }"
            pagination
            class="px-1 pb-2 border"
          >
            <template #footer>
              <tr>
                <td colspan="100%">Total Records: {{ partners.length }}</td>
              </tr>
            </template>
            <template #action="{ item }">
              <td class="pb-2">
                <div class="d-flex">
                  <CButton
                    color="secondary"
                    size="sm"
                    v-if="
                      item.isSource &&
                      item.rawData.relationship_status === 'approved'
                    "
                    v-c-tooltip="'Cancel Partnership'"
                    @click="openModel(item, 'cancel')"
                  >
                    Cancel
                  </CButton>
                  <CButton
                    color="primary"
                    class="mr-1"
                    size="sm"
                    v-if="
                      !item.isSource &&
                      item.rawData.relationship_status === 'pending'
                    "
                    v-c-tooltip="'Approve'"
                    @click="openModel(item, 'approve')"
                  >
                    Approve
                  </CButton>
                  <CButton
                    color="secondary"
                    size="sm"
                    v-if="
                      !item.isSource &&
                      item.rawData.relationship_status === 'pending'
                    "
                    v-c-tooltip="'Reject'"
                    @click="openModel(item, 'reject')"
                  >
                    Reject
                  </CButton>
                </div>
              </td>
            </template>
          </CDataTable>
        </div>
      </CCardBody>
    </CCard>
    <Modal
      :modalTitle="confirmModal.modalTitle"
      :modalColor="confirmModal.modalColor"
      :modalContent="confirmModal.modalContent"
      :isShowPopup="confirmModal.isShowPopup"
      :buttons="confirmModal.buttons"
      :modalCallBack="confirmModalCallBack"
      :closeOnBackdrop="false"
    />
  </div>
</template>
<script>
import Select from "@/components/reusable/Fields/Select.vue";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import Modal from "@/components/reusable/Modal";

export default {
  components: {
    Select,
    Modal,
  },
  data() {
    return {
      customer: {
        organisation_type_id: null,
      },
      page: 1,
      perPage: 10,
      total: 0,

      limit: 10,
      small: true,
      striped: true,
      bordered: true,
      fields: [
        {
          key: "name",
          label: "Name",
          _style: "width:20%",
        },
        {
          key: "type",
          label: "Type",
          _style: "width:20%",
        },
        {
          key: "location",
          label: "Location",
          _style: "width:20%",
        },
        {
          key: "main_contact",
          label: "Main Contact",
          _style: "width:15%",
        },
        {
          key: "status",
          label: "Status",
          _style: "width:10%",
        },
        {
          key: "action",
          label: "Action",
          _style: "width:15%",
        },
      ],
      confirmModal: {
        modalColor: "primary",
        modalTitle: "Confirmation",
        modalContent: "Are you sure to raise the partner request?",
        isShowPopup: false,
        buttons: ["Cancel", "Confirm"],
        data: null,
        status: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getOrganisationTypeList",
      "getCustOrgPartnerRelationship",
      "getOrgTypeIDFromAccessToken",
      "getOrgDetail",
    ]),

    partners() {
      const customer_organisation_id =
        this.getOrgDetail?.customer_organisation_id;
      return this.getCustOrgPartnerRelationship.map((item) => {
        let e = {
          organisation_name: item.source_organisation_name,
          city: item.source_city,
          contact_email: item.source_contact_email,
          contact_name: item.source_contact_name,
          country_name: item.source_country_name,
          customer_organisation_id: item.source_cust_org_id,
          customer_uid: item.source_customer_uid,
          org_type_id: item.source_org_type_id,
          organisation_id: item.source_organisation_id,
          path_acronym: item.source_path_acronym,
        };
        const isSource = item.source_cust_org_id === customer_organisation_id;
        if (isSource) {
          e = {
            organisation_name: item.target_organisation_name,
            city: item.target_city,
            contact_email: item.target_contact_email,
            contact_name: item.target_contact_name,
            country_name: item.target_country_name,
            customer_organisation_id: item.target_cust_org_id,
            customer_uid: item.target_customer_uid,
            org_type_id: item.target_org_type_id,
            organisation_id: item.target_organisation_id,
            path_acronym: item.target_path_acronym,
          };
        }

        return {
          name: e.organisation_name,
          type: this.getOrgType(e.org_type_id)?.label,
          location: `${e?.city || ""}${e?.city && e?.country_name ? ", " : ""}${
            e?.country_name || ""
          }`,
          main_contact: e.contact_name,
          status: _.capitalize(item.relationship_status),
          rawData: item,
          isSource,
        };
      });
    },
  },
  methods: {
    ...mapActions([
      "fetchOrganisationTypeList",
      "showToast",
      "scrollTop",
      "fetchCustOrgPartnerRelationship",
      "fetchUser",
      "updateCusOrgPartnerRelaRequest",
    ]),
    getOrgType(orgTypeId) {
      return this.getOrganisationTypeList.find((org) => org.code === orgTypeId);
    },
    openModel(item, status) {
      this.confirmModal.data = item;
      this.confirmModal.status = status;
      this.confirmModal.isShowPopup = true;
      if (status === "cancel") {
        this.confirmModal.modalContent = `Are you sure you want to ${status} this partnership with ${item.rawData.target_organisation_name}?`;
      } else {
        this.confirmModal.modalContent = `Are you sure you want to ${status} this partnership request?`;
      }
    },
    async confirmModalCallBack(action) {
      this.confirmModal.isShowPopup = false;
      if (action === "Confirm") {
        const data = this.confirmModal.data;
        const statuses = {
          cancel: "cancelled",
          approve: "approved",
          reject: "rejected",
        };
        const status = statuses[this.confirmModal.status];
        await this.updateCusOrgPartnerRelaRequest({
          source_cust_org_id: data.rawData.source_cust_org_id,
          target_cust_org_id: data.rawData.target_cust_org_id,
          status: status,
          isFetchCustOrgPartnerRelationship: true
        });
      }
    },
  },
  mounted() {
    const appendAction = [];

    if (!this.getOrgDetail?.customer_organisation_id) {
      appendAction.push(this.fetchUser());
    }

    Promise.all(appendAction)
      .then(() => {
        this.fetchOrganisationTypeList();
        this.fetchCustOrgPartnerRelationship();
      })
      .finally(() => {
        this.scrollTop();
      });
  },
};
</script>
